import {
    headerColumnTypes,
    ITableHeaderColumn,
    sortDirections,
} from '../../../types/lists/listTypes';
import { ConnetionRequestSource } from '../../../types/zinantis/connectionRequests/connectionRequestTypes';

export const requestsFilterColumnGrid = { xs: 12, sm: 12, md: 6, lg: 3, xl: 3 };

export const PENDING_REQUEST_STATUS_KEY = 'PENDING';

export const requestsListColumns = (
    requestedBy: ConnetionRequestSource
): ITableHeaderColumn[] => [
    {
        id: 'ZinantisConnectionRequestStatus/ZinantisConnectionRequestStatusType/LocalizedCaption',
        labelText: 'status',
        titleText: 'status',
        columnType: headerColumnTypes.SORTABLE,
        sortableProps: {
            sortKey:
                'ZinantisConnectionRequestStatus/ZinantisConnectionRequestStatusType/LocalizedCaption',
            defaultSortDir: sortDirections.ASC,
        },
    },
    {
        id: 'Agency/Name',
        labelText:
            requestedBy === ConnetionRequestSource.OWNER
                ? 'requested_to'
                : 'requested_by',
        titleText:
            requestedBy === ConnetionRequestSource.OWNER
                ? 'requested_to'
                : 'requested_by',
        columnType: headerColumnTypes.SORTABLE,
        sortableProps: {
            sortKey: 'Agency/Name',
            defaultSortDir: sortDirections.ASC,
        },
    },
    {
        id: 'RequestDate',
        labelText: 'request_date',
        titleText: 'request_date',
        columnType: headerColumnTypes.SORTABLE,
        sortableProps: {
            sortKey: 'RequestDate',
            defaultSortDir: sortDirections.DESC,
        },
    },
    {
        id: 'ResolutionDate',
        labelText: 'resolution_date',
        titleText: 'resolution_date',
        columnType: headerColumnTypes.SORTABLE,
        sortableProps: {
            sortKey: 'ResolutionDate',
            defaultSortDir: sortDirections.DESC,
        },
    },
    {
        id: 'actions',
        labelText: 'actions',
        titleText: 'actions',
    },
];
